<template>
  <div
    :class="$style.root"
  >
    <LayoutPageHeaderComponent
      :data="localizedData"
    >
      <div
        v-if=author
        :class="$style.author"
      >
        {{author}}
      </div>

      <CoreDateTimeRangeComponent
        :class="$style.date"
        v-if="localizedData?.date_posted"
        :dateStart="localizedData?.date_posted"
      />
    </LayoutPageHeaderComponent>

    <CoreImageComponent
      v-if="coverImageFromBlocks || localizedData?.cover_image?.data?.attributes"
      :image="coverImageFromBlocks || localizedData?.cover_image?.data?.attributes"
      :class="$style.cover"
    />

    <CoreBlocksComponent
      v-if="blocks"
      :blocks="blocks"
      :class="$style.blocks"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data)))
const firstBlockIsCoverImage = computed(() => pageGetFirstBlocksIsCoverImage(localizedData.value?.blocks))
const coverImageFromBlocks = computed(() => pageGetFirstImageFromBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
const blocks = computed(() => pageGetBlocks(localizedData.value?.blocks, firstBlockIsCoverImage.value))
const author = computed(() => i18nGetLocalizedString(localizedData?.value?.authors))

</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  /* gap: calc(var(--unit--vertical) * 3); */

  --layout--page-header--image--object-fit: contain;
}

.cover {
  --base--image--max-height: var(--100svh);
  --base--image--object-fit: var(--layout--page-header--image--object-fit, cover);
}

.author {
  composes: font-size-large from global;
}

.date {
  composes: font-size-large from global;
}

.blocks {
  margin-top: calc(var(--unit--vertical) * 2);
}
</style>
